import React, { useEffect } from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import SubtitleRegular from 'components/Typography/SubtitleRegular';
import usePentad from 'hooks/Meteorology/Fields/ModelPerformance/usePentad';
import usePeriodType from 'hooks/Meteorology/Fields/ModelPerformance/usePeriodType';
import useOptions from 'hooks/Meteorology/Fields/ModelPerformance/useOptions';
import { store } from 'redux/store';
import { setFilter, switchPentad } from 'redux/reducers/meteorologyFieldsModelPerformanceReducer';
import './index.scss';

const DISABLED_PENTAD_MESSAGE = 'Selecione as opções no painel de controle primeiro';

export default function PentadSelector() {
  const { pentad, setPentad } = usePentad();
  const { periodType } = usePeriodType();
  const { pentads } = useOptions();

  const firstPresetPentad = pentads.find((p) => p.id !== 'livre');
  const livrePentad = pentads.find((p) => p.id === 'livre');

  useEffect(() => {
    if (periodType !== 'preset' || !firstPresetPentad) return;
    const currentInvalid = !pentad || pentad === 'livre'
      || !pentads.some((p) => p.id !== 'livre' && p.id === pentad);
    if (currentInvalid) {
      store.dispatch(setFilter({ pentad: firstPresetPentad.id }));
    }
  }, [periodType, firstPresetPentad, pentad, pentads]);

  useEffect(() => {
    if (periodType !== 'free' || !livrePentad) return;
    if (pentad !== 'livre') {
      store.dispatch(setFilter({ pentad: 'livre' }));
    }
  }, [periodType, livrePentad, pentad]);

  const isPentadEnabled = (pentadId: string) => {
    if (pentadId === 'livre') {
      return periodType === 'free';
    }
    return periodType === 'preset';
  };

  const handlePentadClick = (pentadId: string) => {
    if (!isPentadEnabled(pentadId)) return;
    if (pentadId === 'livre') {
      setPentad(pentadId);
      return;
    }
    // Mantém as escolhas; o usePentadRoundsSync ajusta as rodadas e replota.
    store.dispatch(switchPentad(pentadId));
  };

  return (
    <div className="d-flex justify-content-center">
      <Nav className="round-discrete-tabs">
        {pentads.map((p) => {
          const enabled = isPentadEnabled(p.id);
          const button = (
            <button
              key={p.id}
              type="button"
              onClick={() => handlePentadClick(p.id)}
              disabled={!enabled}
              className={`discrete-nav-link ${pentad === p.id ? 'active' : ''} ${!enabled ? 'disabled' : ''}`}
              style={{
                background: 'none',
                border: 'none',
                cursor: enabled ? 'pointer' : 'not-allowed',
                opacity: enabled ? 1 : 0.5,
                // eventos suprimidos no botão para o <span> receber o hover do tooltip
                pointerEvents: enabled ? undefined : 'none',
              }}
            >
              <SubtitleRegular>{p.label}</SubtitleRegular>
            </button>
          );

          if (enabled) return button;

          return (
            <OverlayTrigger
              key={p.id}
              placement="top"
              overlay={<Tooltip id={`pentad-tooltip-${p.id}`}>{DISABLED_PENTAD_MESSAGE}</Tooltip>}
            >
              <span className="d-inline-block" data-testid={`pentad-wrapper-${p.id}`}>
                {button}
              </span>
            </OverlayTrigger>
          );
        })}
      </Nav>
    </div>
  );
}
